'use strict';

var MetaSocialKey = /*#__PURE__*/function (MetaSocialKey) {
  MetaSocialKey["TWITTER"] = "TWITTER";
  MetaSocialKey["FACEBOOK"] = "FACEBOOK";
  return MetaSocialKey;
}({});
var RelatedType = /*#__PURE__*/function (RelatedType) {
  RelatedType["HTTP_API"] = "HTTP_API";
  RelatedType["HTTP_API_CASE"] = "HTTP_API_CASE";
  RelatedType["DOC"] = "DOC";
  RelatedType["WEB_SOCKET_API"] = "WEB_SOCKET_API";
  RelatedType["CUSTOM_ENDPOINT"] = "CUSTOM_ENDPOINT";
  RelatedType["API_FOLDER"] = "API_FOLDER";
  RelatedType["DATA_SCHEMA"] = "DATA_SCHEMA";
  RelatedType["SOCKET_IO_API"] = "SOCKET_IO_API";
  return RelatedType;
}({});
exports.MetaSocialKey = MetaSocialKey;
exports.RelatedType = RelatedType;
